module.exports = __webpack_public_path__ + "static/media/badgeWeb@3x.a46e7fc2.png";